<template>
  <div>
    <el-dialog
      title="批量录入保单"
      :visible="visible"
      width="50%"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        class="import-policy-info-form"
      >
        <div class="form-item-wrapper">
          <el-form-item label="保险类型" prop="insuranceType">
            <el-select
              v-model="form.insuranceType"
              clearable
              placeholder="请选择保险类型"
            >
              <el-option
                v-for="item in insuranceTypeList"
                :label="item.name"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="保险公司" prop="insuranceCompany">
            <el-select
              v-model="form.insuranceCompany"
              clearable
              filterable
              placeholder="请选择保险公司"
            >
              <el-option
                v-for="(item,index) in insuranceCompanyList"
                :label="item"
                :value="item"
                :key="index"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="车辆信息" prop="fileAddress">
            <el-upload
              action=""
              accept=".xls,.xlsx"
              :fileList="fileList"
              :limit="1"
              :http-request="uploadRequest"
              :autoUpload="true"
              :show-file-list="false"
              :disabled="fileList.length > 0"
              :on-preview="handleFilePreview"
              :on-remove="handleFileMove"
              :before-upload="handleBeforeUpload"
              :on-success="handleOnSuccess"
              :on-error="handleOnError"
            >
              <el-button
                type="minor"
                :loading="fileUploading"
                :disabled="fileList.length > 0"
              >点击上传</el-button>
              <div slot="tip" v-if="fileList.length">
                <div
                  class="file-row"
                  v-for="item in fileList"
                  :key="item.name"
                >
                  <p class="file-name-wrapper">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ item.name }}</span>
                    <i class="el-icon-circle-check"></i>
                  </p>
                  <p class="file-btns">
                    <i
                      class="el-icon-download"
                      @click="() => handleFilePreview(form.fileAddress, item.name)"
                    ></i>
                    <i
                      class="el-icon-delete"
                      v-if="!fileUploading"
                      @click="handleFileMove"
                    ></i>
                  </p>
                </div>
              </div>
            </el-upload>
          </el-form-item>
          <div class="info-slot">
            <el-button type="text" @click="handleDownloadTemplate">下载导入模板</el-button>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          :disabled="!confirmBtnDisabled"
          @click="handleConfirm"
        >创建保单</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { downloadFileByUrl } from '@/utils/download'
import { uploadFile } from '@/api/domain/vehicle'
import { uploadTaskCreate } from '@/api/domain/others'
import { getInsuranceCompanyListV2 } from '@/api/domain/cars'
import {
  INSURANCE_TYPE_LIST,
  BATCH_IMPORT_INSURANCE_POLICY_TEMPLATE,
} from '../../config'

export default {
  props: ['visible'],
  data() {
    return {
      form: {
        insuranceType: '',
        insuranceCompany: '',
        fileAddress: '',
      },
      rules: {
        insuranceType: [
          { required: true, message: '请选择保险类型', trigger: 'change' },
        ],
        insuranceCompany: [
          { required: true, message: '请选择保险公司', trigger: 'change' },
        ],
        fileAddress: [
          { required: true, message: '请上传车辆信息', trigger: 'change' },
        ],
      },
      // 保险类型列表
      insuranceTypeList: INSURANCE_TYPE_LIST,
      // 保险公司列表
      insuranceCompanyList: [],
      fileList: [],
      fileUploading: false,
      submitLoading: false,
      isDestroyed: false,
    }
  },
  computed: {
    confirmBtnDisabled() {
      return this.form.fileAddress && this.form.insuranceType && this.form.insuranceCompany
    },
  },
  methods: {
    handleClose() {
      if (this.fileUploading) {
        this.$message.info('文件正在上传中，请稍后')
        return
      }
      this.$emit('toggleDialogVisible', false)
    },
    handleCancel() {
      this.$emit('toggleDialogVisible', false)
    },
    async handleConfirm() {
      this.$refs.form.validate((isValid) => {
        if (isValid) {
          this.submitLoading = true
          const extInfo = {
            insuranceType: this.form.insuranceType,
            insuranceCompany: this.form.insuranceCompany,
          }
          const data = {
            uploadType: 51, // 51:保单信息导入
            fileAddress: this.form.fileAddress,
            fileName: this.fileList[0].name,
            extInfo: JSON.stringify(extInfo),
          }
          uploadTaskCreate(data).then((res) => {
            const { code } = res || {}
            if (code === 1) {
              this.$emit('toggleDialogVisible', false)
              this.$message.success(
                '开始批量录入保单，可点击“查看录入记录”了解创建进度及结果',
              )
            }
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleBeforeUpload() {
      this.fileUploading = true
      return true
    },
    handleOnSuccess() {
      this.fileUploading = false
    },
    handleOnError() {
      this.fileUploading = false
    },
    handleFilePreview(url, name) {
      if (url && name) {
        downloadFileByUrl(url, name)
      }
    },
    handleFileMove() {
      this.fileUploading = false
      this.fileList = []
      this.form.fileAddress = ''
    },
    handleDownloadTemplate() {
      location.href = BATCH_IMPORT_INSURANCE_POLICY_TEMPLATE
    },
    // 获取保险公司列表
    async getInsuranceCompanyList() {
      try {
        const { code, data } = await getInsuranceCompanyListV2()
        if (code === 1) {
          this.insuranceCompanyList = data
        } else {
          this.$message.error('获取保险公司失败')
        }
      } catch (error) {
        this.$message.error('获取保险公司失败')
      }
    },
    async uploadRequest({ file }) {
      this.fileList = [file]
      this.fileUploading = true

      let res
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('group', 'vehicle')
        formData.append('code', 'vehicle_batch_Insurance_policy_file')
        res = await uploadFile(formData)
      } catch (err) {
        if (err?.message?.includes('timeout') && !this.isDestroyed) {
          this.$message.error('请求超时，请重试！')
          this.handleFileMove()
        }
      }
      this.fileUploading = false

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.form.fileAddress = data
      }
    },
  },
  created() {
    this.getInsuranceCompanyList()
  },
  beforeDestroy() {
    this.isDestroyed = true // 在销毁前设置标志
  },
}
</script>
<style lang="scss" scoped>
.dialogWrap-box {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.import-policy-info-form {
  padding-top: 12px;
}
.form-row {
  margin-bottom: 12px;
}
.info-slot {
  position: relative;
  top: -12px;
  margin-left: 100px;
}
::v-deep .el-form-item.is-error + .info-slot {
  top: -4px;
}
.file-row {
  display: flex;
  justify-content: flex-start;
  .file-name-wrapper {
    display: flex;
    align-items: center;
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    ::v-deep .el-icon-document {
      flex: none;
      margin-right: 2px;
    }
    ::v-deep .el-icon-circle-check {
      flex: none;
      margin-left: 6px;
      color: #67c23a;
    }
  }
  .file-btns {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 24px;
    ::v-deep .el-icon-download:hover {
      color: #409eff;
      cursor: pointer;
    }
    ::v-deep .el-icon-delete {
      margin-left: 8px;
      &:hover {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
</style>
